"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var controlled_input_1 = require("@reverbdotcom/commons/dist/components/controlled_input");
var controlled_checkbox_1 = require("@reverbdotcom/commons/dist/components/controlled_checkbox");
var rql_1 = require("../../schemas/rql");
var country_selector_1 = require("../discovery/country_selector");
var region_select_1 = require("./region_select");
var bind_1 = require("../../bind");
var humps_1 = require("humps");
var I18n = require("i18n-js");
var AddressForm = /** @class */ (function (_super) {
    tslib_1.__extends(AddressForm, _super);
    function AddressForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressForm.prototype.onCountryChange = function (countryCode) {
        var addressAttributes = {
            countryCode: countryCode,
            region: '',
        };
        this.props.onUpdateField(addressAttributes);
    };
    AddressForm.prototype.handleChangeRegion = function (e) {
        var addressAttributes = {
            region: e.target.value,
        };
        this.props.onUpdateField(addressAttributes);
    };
    Object.defineProperty(AddressForm.prototype, "isEuOdrAddress", {
        get: function () {
            return this.props.addressType === rql_1.core_apimessages_MyAddressType.EU_ODR_PLATFORM;
        },
        enumerable: true,
        configurable: true
    });
    AddressForm.prototype.renderEmailInput = function () {
        if (!this.isEuOdrAddress) {
            return null;
        }
        return (React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", { htmlFor: "address-email" }, I18n.t('discovery.addressBook.form.email'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement(controlled_input_1.default, { id: "address-email", fieldName: "email", inputName: "email", inputType: "text", inputValue: this.props.addressFormData.email, updateField: this.props.onUpdateField, required: true }))));
    };
    AddressForm.prototype.renderDefaultCheckbox = function () {
        if (this.isEuOdrAddress) {
            return null;
        }
        if (this.props.addressIsCurrentPrimary) {
            return (React.createElement("p", { className: "form-group__help-text mb-0" }, I18n.t('discovery.addressBook.currentlyDefault')));
        }
        return (React.createElement("div", { className: "label-with-checkbox" },
            React.createElement(controlled_checkbox_1.default, { fieldName: "primary", inputName: "address_primary", checked: this.props.addressFormData.primary, updateField: this.props.onUpdateField }),
            React.createElement("label", { "data-make-primary": true, htmlFor: "address_primary" },
                React.createElement("div", null,
                    I18n.t('discovery.addressBook.form.makeDefault'),
                    React.createElement("p", { className: "form-group__help-text mb-0" }, I18n.t('discovery.addressBook.form.makeDefaultHint'))))));
    };
    AddressForm.prototype.renderError = function (error) {
        return (React.createElement("li", { key: error.field + error.message }, error.message));
    };
    AddressForm.prototype.renderErrors = function () {
        var _this = this;
        if (this.props.errors.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: "alert-box alert-box--red mb-1" }, this.props.errors.map(function (e) { return _this.renderError(e); })));
    };
    AddressForm.prototype.render = function () {
        return (React.createElement("form", { className: "address-form", ref: this.props.formRef },
            this.renderErrors(),
            React.createElement("div", { className: "form-group" },
                React.createElement("div", { className: "form-group__header" },
                    React.createElement("label", { htmlFor: "address-name" }, I18n.t('discovery.addressBook.form.name'))),
                React.createElement("div", { "data-address-form-name": true, className: "form-group__fields" },
                    React.createElement(controlled_input_1.default, { id: "address-name", fieldName: "name", inputName: "name", inputType: "text", inputValue: this.props.addressFormData.name, updateField: this.props.onUpdateField, required: true }))),
            React.createElement("div", { className: "form-group" },
                React.createElement("div", { className: "form-group__header" },
                    React.createElement("label", { htmlFor: "address-country" }, I18n.t('discovery.addressBook.form.country'))),
                React.createElement("div", { className: "form-group__fields" },
                    React.createElement("div", { "data-address-form-countrycode": true, className: "styled-dropdown" },
                        React.createElement(country_selector_1.CountrySelector, { id: "address-country", inputName: "countryCode", onChange: this.onCountryChange, value: this.props.addressFormData.countryCode, countries: humps_1.decamelizeKeys(this.props.countries) })))),
            React.createElement("div", { className: "form-group" },
                React.createElement("div", { className: "form-group__header" },
                    React.createElement("label", { htmlFor: "address-street-address" }, I18n.t('discovery.addressBook.form.streetAddress'))),
                React.createElement("div", { className: "form-group__fields" },
                    React.createElement(controlled_input_1.default, { id: "address-street-address", fieldName: "streetAddress", inputName: "streetAddress", inputType: "text", inputValue: this.props.addressFormData.streetAddress, updateField: this.props.onUpdateField, required: true }),
                    !this.isEuOdrAddress && React.createElement(controlled_input_1.default, { fieldName: "extendedAddress", inputName: "extendedAddress", inputType: "text", inputValue: this.props.addressFormData.extendedAddress, className: "mt-half", updateField: this.props.onUpdateField }))),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: "address-locality" }, I18n.t('discovery.addressBook.form.locality'))),
                        React.createElement("div", { className: "form-group__fields" },
                            React.createElement(controlled_input_1.default, { id: "address-locality", fieldName: "locality", inputName: "locality", inputType: "text", inputValue: this.props.addressFormData.locality, className: "wide required", updateField: this.props.onUpdateField, required: true })))),
                React.createElement("div", { className: "g-col-6 g-col-mobile-12" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: "address-region" }, I18n.t('discovery.addressBook.form.region'))),
                        React.createElement("div", { className: "form-group__fields" },
                            React.createElement(region_select_1.default, { id: "address-region", countries: this.props.countries, countryCode: this.props.addressFormData.countryCode, value: this.props.addressFormData.region, onChange: this.handleChangeRegion }))))),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: "address-postal-code" }, I18n.t('discovery.addressBook.form.postalCode'))),
                        React.createElement("div", { className: "form-group__fields" },
                            React.createElement(controlled_input_1.default, { id: "address-postal-code", fieldName: "postalCode", inputName: "postalCode", inputType: "text", inputValue: this.props.addressFormData.postalCode, className: "wide required", updateField: this.props.onUpdateField, required: true })))),
                React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: "address-phone" }, I18n.t('discovery.addressBook.form.phone'))),
                        React.createElement("div", { className: "form-group__fields" },
                            React.createElement(controlled_input_1.default, { id: "address-phone", fieldName: "phone", inputName: "phone", inputType: "text", inputValue: this.props.addressFormData.phone, className: "wide required", updateField: this.props.onUpdateField, required: true }))))),
            this.renderEmailInput(),
            React.createElement("div", { className: "form-group mb-0" },
                React.createElement("div", { className: "form-group__fields" }, this.renderDefaultCheckbox()))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], AddressForm.prototype, "onCountryChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressForm.prototype, "handleChangeRegion", null);
    return AddressForm;
}(React.Component));
exports.default = AddressForm;
//# sourceMappingURL=address_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/address_form.js
// module id = zEYm
// module chunks = 20 21